<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-nav>
      <glxy-page-nav-button [useHistory]="true"></glxy-page-nav-button>
    </glxy-page-nav>
    <glxy-page-title>{{ 'SALES_COACH_CONFIG.MEETING_SETTINGS' | translate }}</glxy-page-title>
  </glxy-page-toolbar>
  <glxy-page-wrapper>
    <div class="cards">
      <mat-card appearance="outlined">
        <mat-card-header>
          <mat-card-title>{{ 'SALES_COACH_CONFIG.CALENDAR_CONNECTION_CARD.TITLE' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          {{ 'SALES_COACH_CONFIG.CALENDAR_CONNECTION_CARD.DESCRIPTION' | translate }}
          <div class="button-container">
            <button mat-stroked-button [routerLink]="connectionLink">
              {{ 'SALES_COACH_CONFIG.CALENDAR_CONNECTION_CARD.ACTION_V2' | translate }}
            </button>
          </div>
        </mat-card-content>
      </mat-card>
      <mat-card appearance="outlined">
        <mat-card-header>
          <mat-card-title>{{ 'SALES_COACH_CONFIG.FORM.TITLE' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          {{ 'SALES_COACH_CONFIG.FORM.DESCRIPTION_V2' | translate }}
          <div class="button-container">
            <button mat-stroked-button [routerLink]="'/events-and-meetings/meeting-settings'">
              {{ 'SALES_COACH_CONFIG.FORM.ACTION' | translate }}
            </button>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </glxy-page-wrapper>
</glxy-page>
